<template>
  <div id="content">
    <div class="contenair homeop">
      <div class="header">
          <h1>Submission <span style="color: tomato">{{ data['_id'] }}</span></h1>
          <button @click="$router.go(-1)">Go Back</button>
      </div>
      <div class="body" >
        <div class="item" v-for="fieldName in columns">
          <b>{{ fieldName }} </b>: {{ data[fieldName] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      sortDirection: 'asc',
      search: ''
    }
  },
  methods: {
    sort(fieldName) {
      this.sortColumn = fieldName
      if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc'
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = 'asc'
      }
    }
  },
  computed: {
    columns() {
      const arr = []
      Object.keys(this.data).forEach(field => arr.indexOf(field) === -1 && this.data[field].length ? arr.push(field) : null)
      return arr
    }
  },
  mounted() {
    this.$axios
        .get('/api/v2/data/' + this.$route.params.operationId + '/submissions/' + this.$route.params.submissionId)
        .then(res => this.data = res.data[0])
        .catch(() => this.data = [])
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  padding-bottom: 20px;
  border-bottom: 1px solid #3f3f3f;
  display: flex;
  justify-content: space-between;
}
button {
  padding: 5px 15px;
  background: transparent;
  border: 2px solid #6462F2;
  border-radius: 5px;
  color: #6462F2;
  font-weight: bold;
  transition: all 0.3s ease;
}

button:hover {
  background: #6462F2;
  border-color: #000;
  color: #fff;
}



.body .item {
  padding: 10px 20px;
}
</style>